export default __webpack_public_path__ + "static/media/Foto-2020-2.ec349d08.png";